import { render, staticRenderFns } from "./CommonReport.vue?vue&type=template&id=38715220&scoped=true&"
import script from "./CommonReport.vue?vue&type=script&lang=js&"
export * from "./CommonReport.vue?vue&type=script&lang=js&"
import style0 from "./CommonReport.vue?vue&type=style&index=0&id=38715220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38715220",
  null
  
)

export default component.exports